import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const GridHeader = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0.7rem 0;
`

export const GridTitle = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 0;
  max-width: fit-content;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 0.4rem;
  padding-top: 3.3rem;
  padding-bottom: 2rem;
`

export const BoxDescription = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 4rem;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkGray};
`

export const BoxFit = styled.div`
  display: flex;
`

export const SubTitle = styled.p`
  color: #464a53;
  font-size: 1.4rem;
  font-weight: 600;
  padding: 0 1.2rem;
`
export const Box = styled.div`
  display: flex;
  align-items: center;
  .iconFit {
    margin-bottom: -5px;
  }
`

export const BoxTitle = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 600;
  padding-bottom: 1rem;
  width: 15rem;
`
export const BoxLine = styled.p`
  width: 7.7rem;
  border-bottom: 4px solid ${({ theme }) => theme.colors.primary};
`

export const GridFilter = styled(Grid)`
  display: flex;
  margin: 0 -0.8rem;
  width: calc(100% + 16px);
  flex-direction: row;
`

export const FullGrid = styled(Grid)`
  padding: 2.4rem;
`

export const GridInputs = styled(Grid)`
  display: flex;
`

export const GridButtons = styled(Grid)`
  align-self: center;
  text-align: end;
  button + button {
    margin-left: 0.8rem;
  }
`

export const GridInput = styled(Grid)``

export const GridTable = styled(Grid)``

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ButtonText = styled.span`
  margin-left: 12px;
`

export const LinkProtocolCfv = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
`

export const ContentPdf = styled.div`
  .pdf-viewer {
    border-radius: 10px;
    border: none;
    height: 778px;
    width: 100%;
    margin-top: 2.5rem;
    padding: 0;
  }
`

export const ButtonProtocols = styled.div`
  cursor: pointer;
  text-align: center;
`

export const BoxTableCertificates = styled.div`
  margin-top: 50px;
  max-height: 720px;
  overflow-y: scroll;
`
